<script>
export default {
  name: 'TimezoneSelector',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      model: this.value,
      // {name, offset}
      timezones: [],
    };
  },
  computed: {
    options() {
      return this.timezones.map(timezone => {
        return {
          name: `${timezone.name} (${timezone.offset})`,
          value: timezone.name,
        };
      });
    },
  },
  created() {
    this.$api.getTimezones().then((list) => {
      this.timezones = list;
    });
  },
};
</script>

<template>
  <v-select
      v-model="model"
      :options="options"
      :reduce="option => option.value"
      @input="(option) => this.$emit('input', option)"
      label="name"
      :clearable="false"
      :searchable="true"
  />
</template>
